import React from 'react';

import styled from 'styled-components';

import Button from '@atlaskit/button';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';

import { ModalBody, ModalFooter, ModalHeader } from '@qality/common-components';
import { messages } from '@qality/common-messages';

const Wrapper = styled.div`
  height: 115px;
`;

type Props = {
  onClose: () => void;
  onDelete: () => void;
};

export default function DeleteTestStepDialog({
  onClose,
  onDelete,
}: Props): JSX.Element {
  return (
    <ModalTransition>
      <Modal
        onClose={onClose}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEscapePress={true}
        shouldScrollInViewport
      >
        <Wrapper>
          <ModalHeader title='Delete test step' appearance='danger' />
          <ModalBody>Are you sure that you want to delete test step?</ModalBody>
        </Wrapper>
        <ModalFooter>
          <Button appearance='subtle' onClick={onClose}>
            Cancel
          </Button>
          <Button appearance='danger' onClick={onDelete}>
            {messages['testCase.actions.delete.buttonLabel']}
          </Button>
        </ModalFooter>
      </Modal>
    </ModalTransition>
  );
}
